import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import DateAndTime from 'date-and-time';
import { Link } from 'react-router-dom';

import oIconLibrary from 'utils/iconLibrary';
import LinkWithSourcePath from 'utils/LinkWithSourcePath';
import EventLocation from 'components/EventDetails/EventLocation';
import { fnFormatEventDate, fnFormatEventTime } from './helpers';

/**
 * Displays an event's key details, such as the title, date and time, and location.
 */
const EventCard = ({ oEvent }) => {
  const { START_DATE_TIME, END_DATE_TIME } = oEvent;
  const oStartDate = DateAndTime.parse(START_DATE_TIME, 'YYYY-MM-DDTHH:mm:ss');
  const sYear = DateAndTime.format(oStartDate, 'YYYY');

  return (
    <li className='eventCard'>
      <p className='event__dateBlock'>
        <span className='t-label'>
          {fnFormatEventDate(START_DATE_TIME, END_DATE_TIME)}
        </span>
        <br />
        <span>{sYear}</span>
      </p>
      <div className='eventCard__separator'>
        <div className='eventCard__details'>
          <div className='eventCard__detailColumn'>
            <p className='eventCard__detail t-paragraph--small'>
              {oEvent.TITLE}
            </p>
            <p className='eventCard__detail t-paragraph--small'>
              {fnFormatEventTime(START_DATE_TIME, END_DATE_TIME)}
            </p>
          </div>
          <div className='eventCard__detailColumn'>
            <EventLocation oLocation={oEvent.LOCATION} />
          </div>
          <div className='eventCard__detailColumn'>
            <p className='eventCard__detail t-paragraph--small'>
              <FontAwesomeIcon icon={oIconLibrary.fontAwesome.addressCard} />{' '}
              <LinkWithSourcePath
                to={`/main/profile/${oEvent.CONTACT.LOOKUPID}`}
                referringComponent='registeredEvents'
                className='eventCard__detail t-paragraph--small'
              >
                {oEvent.CONTACT.NAME}
              </LinkWithSourcePath>
            </p>
            <a
              href={`mailto:${oEvent.CONTACT.EMAIL}`}
              className='eventCard__detail t-paragraph--small'
            >
              <FontAwesomeIcon icon={oIconLibrary.fontAwesome.envelope} />{' '}
              {oEvent.CONTACT.EMAIL}
            </a>
          </div>
        </div>
      </div>
      <Link
        to={`/events/${oEvent.SLUG}`}
        className='button button--iconOnly--primary'
      >
        <FontAwesomeIcon icon={oIconLibrary.fontAwesome.arrowRight} />
        <span className='hide_accessibly'>View event details</span>
      </Link>
    </li>
  );
};

EventCard.propTypes = {
  oEvent: PropTypes.shape({
    EVENT_ID: PropTypes.string,
    TITLE: PropTypes.string,
    START_DATE_TIME: PropTypes.string,
    END_DATE_TIME: PropTypes.string,
    LOCATION: PropTypes.shape({
      NAME: PropTypes.string,
      ROOM: PropTypes.string,
      ADDRESSBLOCK: PropTypes.string,
    }),
    CONTACT: PropTypes.shape({
      NAME: PropTypes.string,
      EMAIL: PropTypes.string,
      LOOKUPID: PropTypes.string,
    }),
    SLUG: PropTypes.string,
  }).isRequired,
};

export default EventCard;
